import { useEffect, useState } from "react";
import styles from "./cases.module.scss";
import { getCases } from "../../api/api";
import clsx from "clsx";
import { CaseType } from "../../types/types";
import Case from "./case/Case";

const Cases = () => {
  const [cases, setCases] = useState<CaseType[] | null>([
    {
      id: 1,
      name: "Ecobit",
      types: ["Приложение", "Финтех"],
      href: "https://fcore.tech/cases/1",
      preview: "./ecobit.png",
    },
    {
      id: 2,
      name: "KingPay",
      types: ["Веб-платформы", "Финтех"],
      href: "https://fcore.tech/cases/2",
      preview: "./kingpay.png",
    },
    {
      id: 3,
      name: "LiteStore",
      types: ["Веб-дизайн", "E-commerce"],
      href: "https://fcore.tech/cases/3",
      preview: "./litestore.png",
    },
    {
      id: 4,
      name: "PicLoad",
      types: ["Разработка сайта", "лендинг"],
      href: "https://fcore.tech/cases/7",
      preview: "./parfume.png",
    },
    {
      id: 5,
      name: "StonTactics",
      types: ["Веб-приложение", "Игровая платформа"],
      href: "https://fcore.tech/cases/4",
      preview: "./stontactics.png",
    },
    {
      id: 6,
      name: "CityHome",
      types: ["Веб-дизайн", "лендинг"],
      href: "https://fcore.tech/cases/5",
      preview: "./cityhome.png",
    },
    {
      id: 7,
      name: "MyLabParfume",
      types: ["Разработка сайта", "лендинг"],
      href: "https://fcore.tech/cases/6",
      preview: "./parfume.png",
    },
  ]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
      } catch (err) {
        setLoading(false);
        throw err;
      } finally {
        setLoading(false);
      }
    })();
  }, []);
  return (
    <div className={styles.cases}>
      <img src="/logo.svg" alt="logo" style={{ marginLeft: 30 }} />
      <img src="/main_blur.svg" alt="blur" className={styles.cases__blur} />
      <h1>
        Кейсы <span>агентства</span>
      </h1>
      <div className={styles.case__blur} />
      <div className={clsx(styles.case__blur, styles.blur__down)} />
      <div className={styles.case__wrap}>
        {cases?.map((item) => (
          <Case key={item.id} {...item} />
        ))}
      </div>
    </div>
  );
};
export default Cases;
